export default __webpack_public_path__ + "media/titles/title_3_locale_it-61ff2ae9.png";